module.exports = __webpack_public_path__ + "static/media/r114.759550ab.jpg";